module.exports = __webpack_public_path__ + "img/redo-disabled.99d2dd0e.svg";